import RouteError from '@/components/layout/Page/RouteError.vue';
import RouteLoading from '@/components/layout/Page/RouteLoading.vue';

export default [
  {
    path: 'cohort',
    name: 'cohort',
    component: () => import(/* webpackChunkName: "cohort-section" */'@/components/pages/cohort/CohortPane.vue'),
    meta: { title: 'Cohort' },
  },
  {
    path: 'cohort/:id',
    name: 'singleCohort',
    component: () => import(/* webpackChunkName: "cohort-section" */'@/components/pages/cohort/CohortPane.vue'),
    meta: { title: 'Cohort' },
  },
].map((route) => ({
  ...route,
  loading: RouteLoading,
  error: RouteError,
  delay: 200, // Delay before showing the loading component
  timeout: 5000, // The error component will be displayed if a timeout is provided and exceeded
  meta: {
    ...route.meta,
    section: 'Cohort',
  },
}));
